import { PLACE_OF_SERVICE_OPTIONS } from "@/billing/constants/place-of-service";

/**
 * The display label for a `PLACE_OF_SERVICE_OPTIONS` value, as stored on a ChargeItem's
 * `Extensions.ChargeItemPlaceOfService` extension.
 *
 * @returns The option's label, or undefined when the value is undefined or matches no option.
 */
export function getPlaceOfServiceLabel(value: string | undefined): string | undefined {
  if (!value) return undefined;

  return PLACE_OF_SERVICE_OPTIONS.find((option) => option.value === value)?.label;
}
